import { Box, Typography, useMediaQuery } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { BreadcrumbItem } from '@/types/common';
import { SVBreadcrumb } from '../core';
import { useBrandingTheme } from '@/hooks/stores/useBrandingTheme';

type DefaultLayoutProps = {
  header: string;
  subheader?: ReactElement;
  buttons?: ReactElement[];
  breadcrumb?: BreadcrumbItem[];
  children: ReactNode;
};

export default function DefaultLayout({
  header,
  subheader,
  buttons,
  breadcrumb,
  children,
}: DefaultLayoutProps) {
  const { mode } = useBrandingTheme();
  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('lg'));

  return (
    <>
      {breadcrumb && (
        <Box sx={{ mb: 2 }}>
          <SVBreadcrumb items={breadcrumb} />
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: isLargeScreen ? 'row' : 'column',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          mb: 2,
          color: mode === 'light' ? 'black' : 'white',
        }}>
        <Box>
          <Typography variant="h4" component="h1">
            {header}
          </Typography>
          {subheader}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: isLargeScreen ? 'row' : 'column',
            alignItems: 'center',
            width: isLargeScreen ? 'auto' : '100%',
            gap: 2,
          }}>
          {buttons?.map(button => {
            return button;
          })}
        </Box>
      </Box>
      {children}
    </>
  );
}
